import { SessionHelper } from "app/helpers/sessionHelper";
import { OddsType } from "app/utils/const";
import isPublicView from "app/utils/publicViewUtils";
import isEmpty from "lodash/isEmpty";
import { FormattedNumber } from "react-intl";
import { connect } from "react-redux";
import type { UserType } from "../../types/userType";
type Props = {
  user: UserType;
  odds: number;
  oddsType?: string;
  decimalPlaces?: number;
};

// Format number of decimal places for odds
const OddsFormatter = ({ odds, oddsType, user, decimalPlaces }: Props) => {
  const publicViewOddsType = SessionHelper.getOddsType();

  // Defensive: odds must be a valid number for all cases
  if (typeof odds !== "number" || isNaN(odds)) {
    return null;
  }

  const isUSOdds =
    (!isEmpty(user) &&
      !isEmpty(user.preferences) &&
      !isEmpty(user.preferences["oddsType"]) &&
      isEmpty(oddsType) &&
      user.preferences["oddsType"] === OddsType.US) ||
    (!isEmpty(oddsType) &&
      oddsType &&
      oddsType.toUpperCase() === OddsType.US) ||
    (isPublicView() &&
      publicViewOddsType &&
      publicViewOddsType.toUpperCase() === OddsType.US);

  if (isUSOdds) {
    return (
      <span>
        {odds > 0 && "+"}
        {odds}
      </span>
    );
  }

  return (
    <FormattedNumber
      value={odds}
      minimumFractionDigits={decimalPlaces ?? 3}
      maximumFractionDigits={decimalPlaces ?? 3}
    />
  );
};

const mapStateToProps = state => ({
  user: state.userModel.user,
});

export default connect(mapStateToProps, null)(OddsFormatter) as any;
